/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from 'vue-property-decorator'
import { getNosettingList, getRolesList, setUserRole } from '@/api/authority'
import { formatDate } from '@/utils/timeFilter'
import subMenu from '@/components/submenu/index.vue'
import {delNullProperty} from "@/utils";

@Component({
  filters: {
    format: (val: Date)=>(formatDate('yyyy-MM-dd', new Date(val)))
  },
  components: { subMenu }
})
export default class NoSetting extends Vue {
    // ------ 变量 ------
    tableChecked: any = [] // 选中的员工
    dialogVisible = false
    serachName = ''
    page = 1
    total = 0
    limit = 20
    nosettingList = []
    roleList: any = []
    roleId: number | string = ''
    loading = false
    filterPopoverShow = false
    timer = null
    setRoleLoading =  false

    // ------ 生命周期 ------
    created() {
      this.initNosettingList()
      this.initRoleList()
    }

    // ------ 方法 ------
    async initNosettingList() {
        this.loading = true

        const data: any = await getNosettingList(delNullProperty({
            page: this.page,
            limit: this.limit,
            name: this.serachName
        }))
        this.nosettingList = data.result
        this.total = data.allNum
        this.$nextTick(() => {
            (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
        });
        this.loading = false

    }
    async initRoleList() {
      this.roleList = await getRolesList()
    }
    handleSelectionChange(val: any) {
      this.tableChecked = val
    }
    closeDialog() {
      this.dialogVisible = false
      this.tableChecked = [];
      (this.$refs.multipleTable as HTMLFormElement).clearSelection();
    }
    clickSetUserRole(item: any) {
      this.dialogVisible = true
      this.tableChecked.push(item)
    }
    closeSerach() {
      this.serachName = ''
      this.initNosettingList()
    }

    async confirmSetRole() {
        this.setRoleLoading = true
        const arr: string[] = []
        this.tableChecked.forEach((item: any) => {
            arr.push(item.id)
        });
        await setUserRole({userIds: arr, roleId: this.roleId}).then(() => {
            this.$message.success('设置成功')
            this.tableChecked = []
            this.initNosettingList()
            this.roleId = ''
            this.dialogVisible = false
            this.setRoleLoading = false
        }).catch(() => {
            this.setRoleLoading = false
        })
    }

    onSerach(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.filterPopoverShow = false
            this.initNosettingList()
        }, 1000)
    }
    changePage(val: number) {
      this.page = val
      this.initNosettingList()
    }
}
